import styled from "styled-components"

export const WhyUsWrapper = styled.div`
  width: 100%;
  background: #fff;
  color: #091427;
  padding-top: 30px;
  padding-bottom: 70px;
  @media screen and (max-width: 1000px) {
    /* display:none ; */
    padding: 1.714285rem;
    box-sizing: border-box;
    padding-bottom: 3.285714rem;
  }
`
export const WhyUsContainer = styled.div`
  width: 77rem;
  height: 35rem;
  margin: 0 auto;
  display: flex;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    margin: 0;
    height: 100%;
    width: 100%;
    // margin: 0 auto;
  }
  h2 {
    font-size: 1.5rem;
    font-weight: 500;
    @media screen and (max-width: 1000px) {
      font-size: 1.428571rem;
    }
  }
`

export const WInfo = styled.div`
  z-index: 4;
  position: relative;
  width: 50%;
  display: flex;
  align-items: center;
  @media screen and (max-width: 1000px) {
    width: 100%;
    padding-bottom: 60px;
  }
  ul {
    z-index: 100;
    margin-block-start: 0rem;
    margin-block-end: 0rem;
    padding-inline-start: 0rem;
    margin-left: 9.75rem;
    @media screen and (max-width: 1000px) {
      margin: 0 auto;
    }
    li {
      &:last-child {
        margin-top: 2rem;
      }

      display: flex;
      align-items: center;
      // margin-bottom: 1rem;
      img {
        width: 2.625rem;
      }
      .text {
        margin-left: 0.875rem;
        font-size: 20px;
        font-weight: 500;
        @media screen and (max-width: 1000px) {
          font-size: 1rem;
        }
      }

      button {
        z-index: 100;
      }
    }
  }
`

export const WReviews = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-end;
  position: relative;
  img {
    width: 100%;
    // margin-top: -90px;
  }
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    justify-content: unset;
    width: 100%;
  }
`
export const FirstReview = styled.div`
  position: relative;
  width: 27.75rem;
  @media screen and (max-width: 1000px) {
    width: 100%;
    margin: 0px;
  }
  img {
    width: 100%;
  }
  img.logo {
    width: 12rem;
    position: absolute;
    top: -1.6rem;
    right: -3.9rem;
    border-radius: 0.8rem;
    @media screen and (max-width: 1000px) {
      width: 100%;
      right: -2rem;
    }
  }
  img.firstReview {
    width: 27.75rem;
    border-radius: 1.75rem;
    @media screen and (max-width: 1000px) {
      width: 100%;
    }
  }
`

export const SecondReview = styled.div`
  margin-top: 1rem;
  margin-left: -1.75rem;
  margin-bottom: 1rem;
  @media screen and (max-width: 1000px) {
    margin: 0px;
  }
  img {
    width: 31.25rem;
    border-radius: 1.75rem;
    @media screen and (max-width: 1000px) {
      width: 100%;
    }
  }
`

export const ThirdReview = styled.div`
  position: relative;
  @media screen and (max-width: 1000px) {
    margin: 0px;
  }
  img.thirdReview {
    width: 27.75rem;
    border-radius: 1.75rem;
    @media screen and (max-width: 1000px) {
      width: 100%;
      margin-bottom: 40px;
    }
  }
  a {
    position: absolute;
    bottom: -1rem;
    left: 50%;
    transform: translateX(-50%);
    @media screen and (max-width: 1000px) {
      // bottom: -1.6rem;
      // left: 46%;
      width: 100%;
    }
    button {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.625rem 1.25rem;
      border: none;
      outline: none;
      color: #ffffff;
      font-size: 1rem;
      height: 2.6875rem;
      cursor: pointer;
      font-family: "Rubik", sans-serif;
      font-weight: 500;
      background: linear-gradient(96.18deg, #2bb514 1.56%, #1ab502 86.86%);
      border-radius: 4px;
      @media screen and (max-width: 1000px) {
        height: 3.285714rem;
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
      }
      img {
        margin-left: 0.3rem;
        width: 1.125rem;
      }
    }
  }
`

export const WReviewsContainer = styled.div`
  margin-right: 1.75rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 9;
  & > div {
    margin-top: 0px;
    margin-bottom: 0px;
  }
  @media screen and (max-width: 1000px) {
    margin-right: 0;
  }
`
